import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import {
  ReimburseLicenseModalController,
  ReimburseLicenseModalControllerDelegate,
} from "./controller";

interface State {
  isLoading: boolean;
}

interface Props {
  applicationId: number;
  delegate: ReimburseLicenseModalDelegate;
}

const boxStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 600,
  width: "70%",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

/**
 * Delegação para os eventos do componente de modal de ressarcimento.
 */
export interface ReimburseLicenseModalDelegate {
  shouldCloseModal: () => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
  didReimburseLicenses: () => void;
}

class ReimburseLicenseModal
  extends React.Component<Props, State>
  implements ReimburseLicenseModalControllerDelegate
{
  controller: ReimburseLicenseModalController;

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
    };
    this.controller = new ReimburseLicenseModalController(this);
  }

  didReimburseLicenses() {
    this.props.delegate.didReimburseLicenses();
  }

  genericError() {
    this.props.delegate.genericError();
  }

  applicationShouldLogout() {
    this.props.delegate.applicationShouldLogout();
  }

  didClickReimburse() {
    this.setState({ isLoading: true });
    const token = localStorage.getItem("AccessToken")!;
    this.controller.reimburseLicenses(token, this.props.applicationId);
  }

  didClickClose() {
    this.props.delegate.shouldCloseModal();
  }

  renderLoading() {
    return (
      <Box mt={2}>
        <CircularProgress />
      </Box>
    );
  }

  renderForm() {
    return (
      <Box>
        <Typography
          variant="h5"
          component="h2"
          color="primary"
          fontWeight="bold"
        >
          Confirmar Ressarcimento
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Esta ação irá <strong>excluir permanentemente</strong> todas as
          aplicações que foram iniciadas mas <strong>não concluídas</strong>{" "}
          neste lote.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          As licenças utilizadas por elas serão devolvidas à sua conta.
        </Typography>
        <Typography sx={{ mt: 2, fontWeight: "bold" }}>
          Esta ação não pode ser desfeita.
        </Typography>
        <Box m={2} display="flex" flexDirection="row" justifyContent="center" gap={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.didClickReimburse()}
          >
            Ressarcir Licenças
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => this.didClickClose()}
          >
            Cancelar
          </Button>
        </Box>
      </Box>
    );
  }

  render() {
    return (
      <Modal open onClose={() => this.didClickClose()}>
        <Box sx={boxStyle}>
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </Box>
      </Modal>
    );
  }
}

export default ReimburseLicenseModal;
